import { render, staticRenderFns } from "./ManageFacilities.vue?vue&type=template&id=2dd7168f"
import script from "./ManageFacilities.vue?vue&type=script&lang=ts"
export * from "./ManageFacilities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports